function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { getRangeValue, parseAlpha } from "./NumberUtils";
export var RgbColorManager = /*#__PURE__*/function () {
  function RgbColorManager() {
    _classCallCheck(this, RgbColorManager);
    this.key = "rgb";
    this.stringPrefix = "rgb";
  }
  _createClass(RgbColorManager, [{
    key: "handleColor",
    value: function handleColor(color) {
      var _colorValue$rgb;
      var colorValue = color.value,
        rgbColor = (_colorValue$rgb = colorValue.rgb) !== null && _colorValue$rgb !== void 0 ? _colorValue$rgb : color.value;
      if (rgbColor.r !== undefined) {
        return rgbColor;
      }
    }
  }, {
    key: "handleRangeColor",
    value: function handleRangeColor(color) {
      var _colorValue$rgb2;
      var colorValue = color.value,
        rgbColor = (_colorValue$rgb2 = colorValue.rgb) !== null && _colorValue$rgb2 !== void 0 ? _colorValue$rgb2 : color.value;
      if (rgbColor.r !== undefined) {
        return {
          r: getRangeValue(rgbColor.r),
          g: getRangeValue(rgbColor.g),
          b: getRangeValue(rgbColor.b)
        };
      }
    }
  }, {
    key: "parseString",
    value: function parseString(input) {
      if (!input.startsWith(this.stringPrefix)) {
        return;
      }
      var regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i,
        result = regex.exec(input);
      return result ? {
        a: result.length > 4 ? parseAlpha(result[5]) : 1,
        b: parseInt(result[3], 10),
        g: parseInt(result[2], 10),
        r: parseInt(result[1], 10)
      } : undefined;
    }
  }]);
  return RgbColorManager;
}();